import { Vec3D } from "./vec3d";
export class BBox3D {
    constructor() {
        this.min = new Vec3D(Infinity, Infinity, Infinity);
        this.max = new Vec3D(-Infinity, -Infinity, -Infinity);
    }
    merge(b) {
        this.min.imin(b.min);
        this.max.imax(b.max);
    }
    add(v) {
        this.min.imin(v);
        this.max.imax(v);
    }
}
